export default __webpack_public_path__ + "static/media/boris.2a1fd097.png";